import React, { useState } from 'react';
import '../styles/ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    error: false,
    message: '',
    isSubmitting: false
  });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Form doğrulama
    if (!formData.name || !formData.email || !formData.message) {
      setFormStatus({
        submitted: true,
        error: true,
        message: 'Lütfen tüm zorunlu alanları doldurunuz!',
        isSubmitting: false
      });
      return;
    }
    
    // Formu işlemeye başladığımızı göster
    setFormStatus({
      submitted: false,
      error: false,
      message: '',
      isSubmitting: true
    });
    
    // Bağıl yol kullanarak aynı domaine istek at
    const apiUrl = '/api/send-to-teams';
    
    // İstek gönder
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      // Daha iyi hata yakalama için
      if (!response.ok) {
        return response.json().then(data => {
          throw new Error(data.message || 'Bir hata oluştu');
        });
      }
      return response.json();
    })
    .then(data => {
      console.log('Form gönderildi:', data);
      setFormStatus({
        submitted: true,
        error: false,
        message: 'Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.',
        isSubmitting: false
      });
      
      // Formu sıfırla
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    })
    .catch(error => {
      console.error('Form gönderme hatası:', error);
      setFormStatus({
        submitted: true,
        error: true,
        message: `Mesajınız gönderilirken bir hata oluştu: ${error.message || 'Bilinmeyen hata'}`,
        isSubmitting: false
      });
    });
  };
  
  return (
    <div className="contact-page">
      <div className="page-header">
        <div className="container">
          <h1>İletişim</h1>
        </div>
      </div>
      
      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Bize Ulaşın</h2>
              <p>Sorularınız, yorumlarınız veya daha fazla bilgi için lütfen bizimle iletişime geçin.</p>
              
              <div className="info-item">
                <span className="info-icon">📍</span>
                <div>
                  <h3>Adres</h3>
                  <p>Hacettepe, Yılmaz Çk. No:3, 06230 Altındağ/Ankara</p>
                </div>
              </div>
              
              <div className="info-item">
                <span className="info-icon">📱</span>
                <div>
                  <h3>Telefon</h3>
                  <p>+90 312 424 17 44</p>
                  <p>+90 532 399 55 75</p>
                </div>
              </div>
              
              <div className="info-item">
                <span className="info-icon">✉️</span>
                <div>
                  <h3>E-posta</h3>
                  <p>info@phgdanismanlik.com</p>
                </div>
              </div>
              
              <div className="info-item">
                <span className="info-icon">🕓</span>
                <div>
                  <h3>Çalışma Saatleri</h3>
                  <p>Pazartesi - Cuma: 09:00 - 17:30</p>
                </div>
              </div>
            </div>
            
            <div className="contact-form-container">
              <h2>İletişim Formu</h2>
              
              {formStatus.submitted && (
                <div className={`form-message ${formStatus.error ? 'error' : 'success'}`}>
                  {formStatus.message}
                </div>
              )}
              
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Adınız Soyadınız *</label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name" 
                    value={formData.name}
                    onChange={handleChange}
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">E-posta Adresiniz *</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    value={formData.email}
                    onChange={handleChange}
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone">Telefon Numaranız</label>
                  <input 
                    type="tel" 
                    id="phone" 
                    name="phone" 
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="subject">Konu</label>
                  <input 
                    type="text" 
                    id="subject" 
                    name="subject" 
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Mesajınız *</label>
                  <textarea 
                    id="message" 
                    name="message" 
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                
                <button 
                  type="submit" 
                  className="submit-btn" 
                  disabled={formStatus.isSubmitting}
                >
                  {formStatus.isSubmitting ? 'Gönderiliyor...' : 'Gönder'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      
      <section className="map-section">
        <div className="container">
          <div className="section-title">
            <h2>Bizi Bulun</h2>
          </div>
          <div className="map-container">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3059.3082571221985!2d32.870515999999995!3d39.934493999999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d34fa1cb3229a1%3A0x588fd5268b61303a!2zUEhHIERhbsSxxZ9tYW5sxLFrICYgTcO8xZ9hdmlybGlr!5e0!3m2!1sen!2str!4v1747142718622!5m2!1sen!2str" 
              width="100%" 
              height="450" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;